export default "__VITE_ASSET__Mxt0OBkq__"